import React from 'react';

const NoAccessToIncidentWorkflowsMessage = () => (
  <p>Account does not have access to incident_workflows feature</p>
);

export default NoAccessToIncidentWorkflowsMessage;
